<template>
  <div class="pageContent">
    <el-row :span="24" class="serchContent" type="flex">
      <el-col class="search">
        <el-col :span="8"><el-input v-model="attributeName" placeholder="请输入属性名称" size="small"></el-input></el-col>
          <el-button type="primary" size="small" icon="el-icon-search" @click="getList('search')"></el-button>
      </el-col>
      <div :span="14" class="tx_r iconContent" >
            <span class="text">实时刷新</span>
            <el-switch
            @change="freshChange"
            :width="30"
            size="small"
            v-model="isRefresh"
            active-color="#13ce66"
            inactive-color="#dcdfe6">
          </el-switch>
          <div :class="['el-icon-menu',showListFlag?'':'isActive','icon']" @click="showListFlag?showListFlag=!showListFlag:''"></div>
          <div :class="['el-icon-tickets','icon',showListFlag?'isActive':'']" @click="showListFlag?'':showListFlag=!showListFlag"></div>
          <el-tooltip :content="tips" placement="top" effect="light">
                <span class="el-icon-question"></span>
          </el-tooltip>
      </div>
    </el-row>

<transition name="fade-transform" mode="out-in">
  <!-- 数据展示区域卡片 -->
    <div  v-show="!showListFlag">
      <el-row v-if="dataList.length > 0" :span="24">
      <template v-for="(rowItem,rowIndex) in Math.ceil(dataList.length/colCount)" >

         <el-row
          :key="'rowId'+rowIndex"
          :gutter="12">
          <!-- <span>{{rowItem+','+rowIndex}}</span> -->
          <el-col
           v-for="(item,index) in dataList.slice(rowIndex * colCount, (rowIndex * colCount+colCount))"
            :span="6"
            class="card"
             :key="'rowId'+rowIndex+'colId'+index" >
            <el-col :span="16">
              <div>{{item.name}}</div>
              <div style="font-size: 13px;">({{ item.identifier }})</div>
            </el-col>
            <el-col :span="8" class="tx_r checkData">
              <div @click="showData(item.identifier,item.dataType.type)">查看数据</div>
            </el-col>
            <!-- <el-col :span="24">{{item.value}}{{item.dataType&&item.dataType.specs.unit?item.dataType.specs.unit:''}}</el-col> -->
            <el-col>
              <runStateDetailView
                :value="(!isNaN(item.value) || item.value)?item.value:''"
                :item="item"/>
            </el-col>
            <el-col :span="24" class="time">{{item.time}}</el-col>
          </el-col>
         </el-row>
      </template>

    </el-row>
    <emptyView v-if="emptyShow"></emptyView>
    </div>
</transition>
<transition name="fade-transform" mode="in-out">
      <!-- 数据展示区域列表 -->
    <div class="showListView" v-show="showListFlag">
      <el-table
        border
        size="small"
        :data="dataList"
        tooltip-effect="dark"
        style="width: 100%">
        <template slot="empty">
          <emptyView style="margin:10px">
          </emptyView>
        </template>
        <el-table-column
          prop="name"
          label="属性名称">
        </el-table-column>
         <el-table-column
          prop="dataType.type"
          label="数据类型">
        </el-table-column>
        <el-table-column
          prop="time"
          label="更新时间">
        </el-table-column>
        <el-table-column
          label="最新值">
          <template slot-scope="scope">
            <template v-if="['struct','array'].indexOf(scope.row.dataType.type) >= 0 ">
              <runStateDetailView
                :value="(!isNaN(scope.row.value) || scope.row.value)?scope.row.value:''"
                :item="scope.row"/>
            </template>
            <template v-else>
               {{!isNaN(scope.row.value) ||scope.row.value?scope.row.value:''}}
            </template>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          >
          <template slot-scope="scope">
            <div class="checkData" @click="showData(scope.row.identifier,scope.row.dataType.type)">查看数据</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
</transition>

    <!-- 查看数据弹出层 -->
      <checkDataView
      v-if="deviceDetail.deviceName"
      :deviceDetail="deviceDetail"
      :propertyName="propertyName"
      :type="type"
      :data="dataParams"
      @close-data-view="dataParams.dataVisible = false">
      </checkDataView>
      <!-- <div @click="checkData">查看数据</div> -->
  </div>
</template>
<script>
import { deviceShadow } from '@/api/deviceManagement'
import { dataFormat } from '@/utils'
import emptyView from '@/components/empty_view/empty'
import checkDataView from '@/components/deviceManage/checkDataView'
import { eventBus } from '@/utils/eventBus'
import { DATA_TYPE } from '@/assets/js/defition'
import runStateDetailView from '@/components/deviceManage/runStateDetailView'
export default {
  props: ['deviceDetail', 'properties'],
  components: {
    emptyView,
    checkDataView,
    runStateDetailView
  },
  data () {
    return {
      // list: [0, 1, 2, 3], // 暂时做循环用
      dataList: [],
      showListFlag: false, // 用于展示是否显示成列表，默认false
      attributeName: '',
      dataParams: {
        dataVisible: false
      },
      tips: '设备数据上报的最新属性值，点击“查看数据”可以查看指定属性的历史数据',
      isRefresh: false,
      emptyShow: false,
      propertyName: '',
      DATA_TYPE: DATA_TYPE,
      colCount: 4, // 每行显示的个数
      type: ''
    }
  },
  methods: {
    initKey2Chinese (list) {
      this.key2chinese = {}
      this.dataList = []
      list.map(item => {
        // const model = {
        //   name: item.name,
        //   unitName: item.dataType.specs.unitName,
        //   dataType: item.dataType,
        //   // 以下的字段主要用查看数据调用接口所用
        //   propertyName: item.identifier
        // }
        this.key2chinese[item.identifier] = item
        // 物模型得数据获取到后就先展示
        if (item.identifier !== 'ipaddress' && item.identifier !== 'activationTime' && item.identifier !== 'deviceStatus') {
          this.dataList.push(item)
        }
      })
    },
    getDeviceShadow () {
      const params = {
        productKey: this.deviceDetail.productKey,
        deviceName: this.deviceDetail.deviceName
      }
      console.log('getDeviceShadow params:', params)
      deviceShadow(params).then(res => {
        const resData = res.data.data
        // 保留原始数据，过滤逻辑单独开来
        this.deviceProperties = resData || []
        // 将数据进行整合
        this.getList()
      })
    },
    getList (search) {
      console.log('this.getList')
      this.dataList = []
      Object.keys(this.deviceProperties).forEach(key => {
        if (key !== 'ipaddress' && key !== 'activationTime' && key !== 'deviceStatus') {
          if (this.key2chinese[key]) {
            Object.assign(this.key2chinese[key], this.deviceProperties[key], {
              time: dataFormat(this.deviceProperties[key].time)
            })
          }
        }
      })
      const that = this
      const dataList = []
      Object.keys(this.key2chinese).forEach(key => {
        if (search && this.attributeName) {
          if (that.attributeName === key || this.key2chinese[key].name.indexOf(that.attributeName) > -1) {
            if (this.key2chinese[key].identifier !== 'ipaddress' && this.key2chinese[key].identifier !== 'activationTime' && this.key2chinese[key].identifier !== 'deviceStatus') {
              dataList.push(this.key2chinese[key])
            }
          }
        } else {
          if (this.key2chinese[key].identifier !== 'ipaddress' && this.key2chinese[key].identifier !== 'activationTime' && this.key2chinese[key].identifier !== 'deviceStatus') {
            dataList.push(this.key2chinese[key])
          }
        }
      })
      this.dataList.splice(0, this.dataList.length, ...dataList)
      this.dataList.length > 0 ? this.emptyShow = false : this.emptyShow = true
      console.log('处理后的this.dataList：', this.dataList)
    },
    showData (propertyName, type) {
      this.propertyName = propertyName
      this.type = type
      this.$nextTick(() => {
        this.dataParams.dataVisible = true
      })
    },
    freshChange (val) {
      console.log('点击了开关：', val)
      const freshTime = 3000
      val
        ? this.freshInterval
          ? (window.clearInterval(this.freshInterval), this.freshInterval = setInterval(() => { this.initData() }, freshTime))
          : this.freshInterval = setInterval(() => { this.initData() }, freshTime)
        : window.clearInterval(this.freshInterval)
    },
    initData () {
      this.initKey2Chinese(this.properties)
      this.getDeviceShadow()
    }
  },
  created () {
    // 注册一个监听事件，当tab切换到其他地方时候，清除定时器
    eventBus.$on('clearFreshInterval', () => {
      this.freshInterval
        ? (window.clearInterval(this.freshInterval), this.isRefresh = false)
        : ''
    })
    console.log('获取得deviceDetail：', this.deviceDetail)
    this.initData()
  },
  beforeDestroy () {
    this.freshInterval
      ? window.clearInterval(this.freshInterval)
      : ''
  }
}
</script>
<style lang="less" scope>

.pageContent{
  .tx_r{
    text-align: right;
  }
  .iconContent{
    padding-right: 1%;
    font-size: 25px;
    color: #606266;
    display: flex;
    align-items: center;
    .text{
      font-size: 12px !important;
      word-break: keep-all;
      margin-right: 5px;
    }
    .isActive{
       color:rgb(0, 112, 204);
    }
    .icon{
      cursor: pointer;
    }
    .el-icon-question{
      margin-left: 5px;
      color: rgb(204, 204, 204);
    }
  }
  .serchContent{
    margin-bottom: 10px;
    .el-button{
      margin-left: 10px;
    }
    .search{
      flex: auto;
    }
  }
  .card{
    box-shadow: 0 1px 4px 0 rgba(0,0,0,.08);
    border: 1px solid #f2f2f2;
    padding-top: 15px;
    line-height: 30px;
    width: 24% !important;
    margin-right: 1%;
    margin-top: 10px;
    min-height: 120px;
    .el-col{
      padding-left: 15px;
      padding-right: 15px;
    }
     .checkData{
        color:rgb(0, 112, 204);
        font-size: 12px;
        cursor: pointer;
      }
      .time{
        color: #888888;
        font-size: 12px;
      }
  }
  .showListView{
    .checkData{
        color:rgb(0, 112, 204);
        font-size: 12px;
        cursor: pointer;
      }
  }

}

.pageCon{
  .tx-c{
    text-align: center;
  }
  .greenBorder{
    border: solid 2px #67a7ba;
    margin-right: 10px;
    background-color: #f5f5f6;
  }
  .ordinary{
    display: flex;
    align-items: center;
    border-bottom: solid 1px #dddddd;
    margin: 0 15px;
    .icon{
      font-size: 25px;
      color: #0d9bf2;
    }
     .thirdState{
      font-size: 20px;
    }
    .state{
      color: #138c4b;
      font-size: 20px;
    }
    el-row:nth-child(1){
      height: 100px;
    }
    &:nth-child(1){
      height: 80px;
    }
    &:nth-child(n+2){
      height: 130px;
    }
  }

  .special{
    height: 470px;
    display: flex;
    flex-direction: column;
    .el-col{
      flex-grow: 1;
      display: flex;
       justify-content: center;
      align-items: center;
      &:nth-child(1){
        font-weight: bold;
      }
      .circle{
        background-color: #409EFF;
        border-radius: 50%;
        width: 25px;
        height: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        font-size: 10px;
        margin-right: 50px;
      }
    }
  }

}
</style>
